import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { handleMessage, rePairDevice } from './notifications';
import { getContext, storeToken } from './service';
import { userContractId } from '../util';
import { getNotificationLogger } from './log';
import { isSupported } from 'firebase/messaging';

export function reqNotifyPermThenSync() {
    return Notification.requestPermission().then(permission => {
        if (permission === 'granted' && 'serviceWorker' in navigator) {
            return navigator.serviceWorker.getRegistration().then(initFirebaseMessaging);
        }
    });
}

// @ts-ignore
const { apiKey, appId, messagingSenderId, projectId, vapidKey } = window.FIREBASE_CONFIG;
let messaging;

const log = getNotificationLogger('init');
log('support', notificationsBrowserInfo());

export function initFirebaseMessaging(serviceWorkerRegistration) {
    if (!messaging) {
        messaging = getMessaging(initializeApp({ apiKey, appId, messagingSenderId, projectId }));
    }
    if (Notification.permission === 'granted') {
        onMessage(messaging, handleMessage);
        return loadToken(serviceWorkerRegistration)
            .then(storeToken)
            .then(checkUserChange)
            .catch(e => console.error('Cannot get messaging token', e));
    }
}

function loadToken(serviceWorkerRegistration) {
    const { token } = getContext();
    return token ? Promise.resolve(token) : getToken(messaging, { vapidKey, serviceWorkerRegistration });
}

export function checkUserChange(token) {
    const currentUserContractId = userContractId();
    const { contractId } = getContext();
    log('checkUserChange', { contractId, currentUserContractId });

    // ak user nie je prihlaseny alebo nie je subscribnuty na notifikacie => nerobime nic
    if (!currentUserContractId || !contractId) {
        return token;
    }

    // ak je prihlaseny iny user ako subscribnuty, subscribnuteho odregistrujeme
    if (currentUserContractId !== contractId) {
        rePairDevice();
    }

    return token;
}

function notificationsBrowserInfo() {
    const supported = window.Notification && isSupported();
    const denied = supported && window.Notification.permission === 'denied';
    const granted = supported && window.Notification.permission === 'granted';

    return {
        supported,
        denied,
        granted
    };
}
